(function($, Drupal, once) {
  Drupal.behaviors.jnjmdcCardsRowDiscoverZebra = {
    attach(context) {
      $(
        once(
          'discover-zebra',
          '.paragraph--type--jnjmdc-paragraph-cards-row',
          context
        )
      ).each(function() {
        const discoverZebra = new Drupal.jnjos.DiscoverZebra($(this));
        const zebraColorClass =
          discoverZebra.getZebraBackgroundColor() === 'rgb(244,244,244)'
            ? 'jnjmdc-card-row-zebra-gray'
            : 'jnjmdc-card-row-zebra-white';

        // We'll apply the hover state only if it has a link.
        const cardWrapper = $(this).find('.card--wrapper');
        const cardParagraph = $(this);
        if (cardWrapper && cardWrapper.length > 0) {
          $(once('add-zebra-class', cardWrapper)).each(function() {
            // For blue, magenta and custom color we need to add the class on the parent div.
            if (
              cardParagraph.hasClass('card-row-magenta') ||
              cardParagraph.hasClass('card-custom-color') ||
              cardParagraph.hasClass('card-row-blue')
            ) {
              $(this)
                .parent()
                .addClass(zebraColorClass);
            } else {
              $(this).addClass(zebraColorClass);
            }
          });
        }
      });
    },
  };
  Drupal.behaviors.jnjmdcCardsRowReactDiscoverZebra = {
    attach() {
      $('div[react-component="cards_row"]').each(function() {
        const discoverZebra = new Drupal.jnjos.DiscoverZebra($(this));
        const backgroundColorZebraContentElement = discoverZebra.getZebraBackgroundColor();
        const grayColor = 'rgb(244,244,244)';
        const isAccent = backgroundColorZebraContentElement === grayColor;
        let dataProps = $(this).attr('data-props');
        if (!dataProps) {
          return false;
        }
        dataProps = JSON.parse(dataProps);
        dataProps.isAccent = isAccent;
        $(this).attr('data-props', JSON.stringify(dataProps));
        return dataProps;
      });
    },
  };
})(jQuery, Drupal, once);
